import { render, staticRenderFns } from "./_.vue?vue&type=template&id=64d1d2fa&scoped=true&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./_.vue?vue&type=style&index=0&id=64d1d2fa&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "64d1d2fa",
  "0d5f04be"
  
)

export default component.exports